import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import Register from './views/Register'
import Agreement from "./components/landing/Agreement";
import Landing from "./components/landing/Landing";
import Confidential from "./components/landing/Confidential";
import Banking from "./components/landing/Banking";
import $route from 'vue-router'

Vue.use(Router);

function get_invite(){
  // extract ?invite=FOO from query string, store it to localstorage.
  let query_string = window.location.search.substring(1);
  let params = new URLSearchParams(query_string);
  let invite =  params.get("invite");
  if (invite){
    localStorage.invite = invite;
  }
  return localStorage.invite;
}




export const router = new Router({
  mode: 'history',
  linkActiveClass: 'is-active',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'home',
      component: Home,
      meta: {title: "Croinc.ru: cистема онлайн-записи "},
      children: [
        {
          path: '/',
          name: 'landing',
          component: Landing,
          meta: {title: "Croinc.ru: cистема онлайн-записи "}
        },
        {
          path: '/agreement',
          name: 'agreement',
          component: Agreement,
          meta: {title: "Croinc.ru: cистема онлайн-записи "}
        },
        {
          path: '/banking',
          name: 'banking',
          component: Banking,
          meta: {title: "Croinc.ru: cистема онлайн-записи "}
        },
        {
          path: '/confidential',
          name: 'confidential',
          component: Confidential,
          meta: {title: "Croinc.ru: cистема онлайн-записи "}
        }]
    },
    {
      path: '/register/confirm_email/:emailtoken/',
      name: 'confirm',
      component: Register,
      props: {invite: get_invite(),},
      meta: {title: "Croinc.ru: подтверждение email и номера телефона"}
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      props: {invite: get_invite()},
      meta: {title: "Croinc.ru: регистрация"}
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

router.beforeEach((to, from, next)=> {
  document.title = to.meta.title;
  next();
});
